<template>
    <div
        :class="[
            'img-swiper-container',
            {
                pc: isPc
            }
        ]"
        :style="[cssProperties, slideSize]"
    >
        <div class="swiper img-swiper" ref="swiper">
            <div class="swiper-wrapper">
                <div v-for="(slide, i) in slideImgs" class="swiper-slide">
                    <renderer :key="slide.id" :tpl="slide" :style="parseStyle(slide.style)"></renderer>
                </div>
            </div>
            <div v-show="!isPreRender" class="swiper-pagination"></div>
        </div>
    </div>
</template>
<script>
import './flat';
import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
const {
    library: { ramda },
    renderer,
    store: { variable }
} = window.FEGORender;
const {
    state: { initCmpStateMatchine }
} = window.FEGOBridge;
const {
    rem: { parseStyle }
} = window.FEGOUtils;
import Core from './core.vue';
export default {
    mixins: [Core],
    data() {
        return {
            isPreRender: FEGORender.common.env.isPreRender,
        };
    },
    components: {
        renderer
    },
    computed: {
        slideImgs() {
            const { children = [] } = this.tpl;
            const imgTpl = [];
            children.forEach((child) => {
                if (child.type === 'img') {
                    imgTpl.push(ramda.mergeDeepRight(child, initCmpStateMatchine(child, variable.data)));
                }
            });
            return imgTpl;
        }
    },
    watch: {},
    methods: {
        initSwiper() {
            const $swiper = this.$refs['swiper'];
            this.swiper = new Swiper($swiper, {
                modules: [Autoplay, Pagination],
                spaceBetween: this.slideSpace,
                loop: this.loop,
                slidesPerView: 'auto', // 大小自适应
                centeredSlides: this.centeredSlides, // 居中
                autoplay: this.autoPlay && {
                    delay: this.autoPlayDelay || 3000, // 每隔3秒自动播放
                    disableOnInteraction: false // 被用户交互之后，会继续自动播放
                },
                pagination: {
                    el: '.swiper-pagination'
                    // clickable: true
                }
            });
        },
        parseStyle
    },
    mounted() {
        !this.isPreRender && this.$nextTick(this.initSwiper);
    }
};
</script>
<style lang="less" scoped>
@import '../render/index.less';
</style>
